
import React, { useContext, useEffect } from "react";
import { LanguageContext } from "../../context/LanguageContext";  

const About = () => {
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);
  
  useEffect(() => {
    loadLanguageFile("About", "about/about_body_lang");
  }, [language]);
  const LANGUAGE = componentLanguageData.About || { Main: {} };
  return (
    <div
      className="container-fluid py-5 wow fadeInUp"
      data-wow-delay="0.1s"
      style={{ visibility: 'visible', animationDelay: '0.1s', animationName: 'fadeInUp' }}
    >
      <div className="container py-5">
        <div className="row g-5">
          {/* 左側文字內容 */}
          <div className="col-lg-7">
            <div className="section-title position-relative pb-3 mb-5">
              <h5 className="fw-bold text-primary text-uppercase">{LANGUAGE.Main.Content1}</h5>
              <h1 className="mb-0">{LANGUAGE.Main.Content2}</h1>
            </div>
            <p className="mb-4">
            {LANGUAGE.Main.Content3}
            </p>
            <p className="mb-4">
            {LANGUAGE.Main.Content4}
            </p>
            <p className="mb-4">
            {LANGUAGE.Main.Content5}
            </p>
            <div className="row g-0 mb-3">
              <div
                className="col-sm-6 wow zoomIn"
                data-wow-delay="0.2s"
                style={{ visibility: 'visible', animationDelay: '0.2s', animationName: 'zoomIn' }}
              >
                <h5 className="mb-3">
                  <i className="fa fa-check text-primary me-3"></i>{LANGUAGE.Main.Content6}
                </h5>
                <h5 className="mb-3">
                  <i className="fa fa-check text-primary me-3"></i>{LANGUAGE.Main.Content7}
                </h5>
                <h5 className="mb-3">
                  <i className="fa fa-check text-primary me-3"></i>{LANGUAGE.Main.Content13}
                </h5>
              </div>
              <div
                className="col-sm-6 wow zoomIn"
                data-wow-delay="0.4s"
                style={{ visibility: 'visible', animationDelay: '0.4s', animationName: 'zoomIn' }}
              >
                <h5 className="mb-3">
                  <i className="fa fa-check text-primary me-3"></i>{LANGUAGE.Main.Content8}
                </h5>
                <h5 className="mb-3">
                  <i className="fa fa-check text-primary me-3"></i>{LANGUAGE.Main.Content9}
                </h5>
                <h5 className="mb-3">
                  <i className="fa fa-check text-primary me-3"></i>{LANGUAGE.Main.Content14}
                </h5>
              </div>
            </div>
            {/* <div
              className="d-flex align-items-center mb-4 wow fadeIn"
              data-wow-delay="0.6s"
              style={{ visibility: 'visible', animationDelay: '0.6s', animationName: 'fadeIn' }}
            >
              <div
                className="bg-primary d-flex align-items-center justify-content-center rounded"
                style={{ width: '60px', height: '60px' }}
              >
                <a href={`tel:${LANGUAGE.Main.Content11}`}><i className="fa fa-phone-alt text-white"></i></a>
              </div>
              <div className="ps-4">
                <h5 className="mb-2">{LANGUAGE.Main.Content10}</h5>
                <a href={`tel:${LANGUAGE.Main.Content11}`}><h4 className="text-primary mb-0">{LANGUAGE.Main.Content11}</h4></a>
              </div>
            </div> */}
            <a
              href="/contact"
              className="btn btn-primary py-3 px-5 mt-3 wow zoomIn"
              data-wow-delay="0.9s"
              style={{ visibility: 'hidden', animationDelay: '0.9s', animationName: 'none' }}
            >
              {LANGUAGE.Main.Content12}
            </a>
          </div>
          {/* 右側圖片 */}
          <div className="col-lg-5" style={{ minHeight: '500px' }}>
            <div className="position-relative h-100">
              <img
                className="position-absolute w-100 h-100 rounded wow zoomIn"
                data-wow-delay="0.9s"
                src="img/about.jpg"
                alt={LANGUAGE.Main.Content1}
                style={{
                  objectFit: 'cover',
                  visibility: 'visible',
                  animationDelay: '0.9s',
                  animationName: 'zoomIn',
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
